module.exports = __webpack_public_path__ + "static/media/blue-cross.80ae9cc6.svg";